import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { deepMix } from '@antv/util';
import { defined } from '../utils/helper';
import { columnOf } from './utils/helper';
function normalizeValue(value) {
  if (typeof value === 'object') return [value.value, value.ordinal];else return [value, true];
}
/**
 * The Filter transform filter channels.
 */
export var Filter = function Filter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (I, mark) {
    var encode = mark.encode,
      data = mark.data;
    var filters = Object.entries(options).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        v = _ref2[1];
      var _columnOf = columnOf(encode, key),
        _columnOf2 = _slicedToArray(_columnOf, 1),
        V = _columnOf2[0]; // Skip empty channel.
      if (!V) return null;
      var _normalizeValue = normalizeValue(v),
        _normalizeValue2 = _slicedToArray(_normalizeValue, 2),
        value = _normalizeValue2[0],
        _normalizeValue2$ = _normalizeValue2[1],
        ordinal = _normalizeValue2$ === void 0 ? true : _normalizeValue2$;
      if (typeof value === 'function') return function (i) {
        return value(V[i]);
      };
      if (ordinal) {
        var expectedValues = Array.isArray(value) ? value : [value];
        // Skip empty expected values.
        if (expectedValues.length === 0) return null;
        return function (i) {
          return expectedValues.includes(V[i]);
        };
      } else {
        var _value = _slicedToArray(value, 2),
          start = _value[0],
          end = _value[1];
        return function (i) {
          return V[i] >= start && V[i] <= end;
        };
      }
    }).filter(defined);
    // Skip empty filters.
    if (filters.length === 0) return [I, mark];
    // Filter index and channels.
    var totalFilter = function totalFilter(i) {
      return filters.every(function (f) {
        return f(i);
      });
    };
    var FI = I.filter(totalFilter);
    var newIndex = FI.map(function (_, i) {
      return i;
    });
    var newEncodes = Object.entries(encode).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        encode = _ref4[1];
      return [key, Object.assign(Object.assign({}, encode), {
        value: newIndex.map(function (i) {
          return encode.value[FI[i]];
        })
      })];
    });
    return [newIndex, deepMix({}, mark, {
      encode: Object.fromEntries(newEncodes),
      // Filter data for tooltip item.
      data: FI.map(function (i) {
        return data[i];
      })
    })];
  };
};
Filter.props = {};